import _isEmpty from "lodash/isEmpty";
import _get from "lodash/get";
import Vue from "vue";
import { getUserProperties } from "@/utils/userTrackingProperties";

const state = {
    data: {},
    newsletters: [],
    token: null
};

const mutations = {
    SET_DATA(state, data) {
        state.data = data;

        Vue.gtm.trackEvent({
            event: "authentication",
            userId: data.user.user_id
        });

        if (process.env.NODE_ENV !== "development") {
            const isEmailLogin = _isEmpty(data.facebook);
            // Set Global Sentry Scope
            Sentry.configureScope(scope => {
                scope.setTag("login-type", isEmailLogin ? "email" : "facebook");
                scope.setUser({
                    id: data.user.user_id,
                    email: isEmailLogin
                        ? data.email
                        : data.facebook.email_address
                });
            });
            const email = isEmailLogin
                ? data.email
                : data.facebook.email_address;

            Leanplum.setUserId(data.user.user_id);

            const userAttributes = {
                email,
                backend_id: data.user.user_id,
                first_name: data.user.first_name
            };
            Leanplum.setUserAttributes(userAttributes);
        }
        if (!_isEmpty(analytics)) {
            analytics.identify(data.user.user_id, getUserProperties({}, data));
        }
    },
    SET_TOKEN(state, token) {
        state.token = token;
    },
    SET_COSTUMER_ID(state, customerId) {
        state.customerId = customerId;
    },
    CLEAN_UP_DATA(state) {
        state.data = {};
        state.token = null;
        if (process.env.NODE_ENV !== "development") {
            Sentry.configureScope(scope => scope.clear());
        }

        if (!_isEmpty(analytics)) {
            analytics.reset();
        }
    },
    SET_NEWSLETTERS(state, newsletters) {
        state.newsletters = newsletters;
    }
};

const actions = {
    getData({ dispatch }) {
        return Promise.all([dispatch("getInfo")]).then(response => {
            dispatch("setData", response[0].data);
        });
    },
    setData({ commit }, payload) {
        commit("SET_DATA", payload);
    },
    setToken({ commit }, token) {
        commit("SET_TOKEN", token);
    },
    setCustomerId({ commit }, customerId) {
        commit("SET_CUSTOMER_ID", customerId);
    },
    setFirstName({ commit }, firstName) {
        const data = Object.assign({}, state.data, { first_name: firstName });
        commit("SET_DATA", data);
    },
    // eslint-disable-next-line no-empty-pattern
    async checkIfEmailExists({}, email) {
        return await axios
            .get(`/v2/checkemail?email=${email}`)
            .then(response => response.data.exists);
    },
    addToInsightsNewsletter() {
        const email =
            _get(state.data, "user.email_address") ||
            _get(state.data, "facebook.email_address") ||
            _get(state.data, "email");
        const data = new FormData();
        data.append("email", email);
        axiosCms
            .post("/site/subscription/daily-insights", data)
            .then(() => localStorage.setItem("bi-subscribed", true));
    },
    getInfo() {
        return axios.get("/v2/user");
    },
    getArchivedInsights({}, query = "") {
        return axiosCms.get(`/site/newsletters${query}`);
    },
    updateUser({ dispatch, commit }, query = "") {
        dispatch("Application/showLoader", true, { root: true });

        dispatch("getArchivedInsights", query).then((newsletters) => {
            commit("SET_NEWSLETTERS", newsletters.data);
        }).finally(() => {
            dispatch("Application/showLoader", false, { root: true });
        })
    },
    cleanUpData({ commit, dispatch }) {
        commit("CLEAN_UP_DATA");
        dispatch("UserMembership/cleanUpData", null, { root: true });
        dispatch("UserLibrary/cleanUpData", null, { root: true });
    }
};

const getters = {
    isLoggedIn(state) {
        return state.token != null;
    },
    loginType(state) {
        if (!_isEmpty(state.data.facebook)) {
            return "facebook";
        } else if (!_isEmpty(state.data.user)) {
            return "email";
        }
        return "";
    },
    userProfileImage(state) {
        const images = state.data.image;
        const hasProfileImage = !_isEmpty(images) && images["100"];

        if (!hasProfileImage) {
            return "";
        }

        return images["100"];
    },
    userIsReady(state) {
        return !_isEmpty(state.data);
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};
